import React from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';
import { useYear } from '../../../hooks/useYear';
import useStyles from './styles';

const YearSelector: React.FC = () => {
  const classes = useStyles();
  const { selectedYear, changeYear, getAvailableYears } = useYear();

  const handleYearChange = (event: SelectChangeEvent<number>) => {
    changeYear(event.target.value as number);
  };

  const availableYears = getAvailableYears();

  // Debug: verificar valores
  // console.log('Selected Year:', selectedYear);
  // console.log('Available Years:', availableYears);

  return (
    <Box className={classes.yearSelectorContainer}>
      <Typography
        variant="body2"
        className={classes.yearLabel}
        component="div"
      >
        <CalendarIcon className={classes.yearIcon} />
        Año
      </Typography>
      <Select
        value={selectedYear}
        onChange={handleYearChange}
        className={classes.yearSelect}
        size="small"
        variant="outlined"
        renderValue={(value) => value || selectedYear}
      >
        {availableYears.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default YearSelector;
